// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".positive[data-v-cd6c2638]{--text-opacity:1;color:#27ae60;color:rgba(39,174,96,var(--text-opacity))}.positive svg path[data-v-cd6c2638]{fill:#27ae60}.negative[data-v-cd6c2638]{--text-opacity:1;color:#e04067;color:rgba(224,64,103,var(--text-opacity))}.negative svg[data-v-cd6c2638]{-webkit-transform:scaleY(-1);transform:scaleY(-1)}.negative svg path[data-v-cd6c2638]{fill:#e04067}", ""]);
// Exports
module.exports = exports;
